<template>
    <div>
        <h1 class="display-heading">Change Password</h1>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group required">
                    <label>Current Password</label>

                    <input type="password" name="currentPassword" ref="currentPassword"
                        data-vv-as="current password" data-vv-validate-on="blur"
                        placeholder="Enter Your Current Password" v-model="form.currentPassword" v-validate="'required'"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('currentPassword')
                        }">

                    <div v-show="validationErrors.has('currentPassword')" class="invalid-feedback">
                        {{ validationErrors.first('currentPassword') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group required">
                    <label>New Password</label>

                    <input type="password" name="newPassword" ref="newPassword" data-vv-as="new password" data-vv-validate-on="blur"
                        placeholder="Enter Your New Password" v-model="form.newPassword" v-validate="'required'"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('newPassword')
                        }">

                    <div v-show="validationErrors.has('newPassword')" class="invalid-feedback">
                        {{ validationErrors.first('newPassword') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group required">
                    <label>Confirm New Password</label>

                    <input type="password" name="confirmNewPassword" ref="confirmNewPassword" data-vv-as="confirm new password" data-vv-validate-on="blur"
                        placeholder="Confirm Your New Password" v-model="form.confirmNewPassword" v-validate="'required|confirmed:newPassword'"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('confirmNewPassword')
                        }">

                    <div v-show="validationErrors.has('confirmNewPassword')" class="invalid-feedback">
                        {{ validationErrors.first('confirmNewPassword') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-2" :style="resetSuccess ? '' : 'color: red;'" v-if="changePasswordMessage">{{ changePasswordMessage }}</div>
        <button @click="submitChangePassword" class="btn btn-primary btn-primary-insv mr-2">Change My Password</button>
        <button @click="cancelChangePassword" class="btn btn-secondary" type="button">Cancel</button>

    </div>

</template>

<script>
export default {
    'name': 'ChangePassword',
    data () {
        return {
            'form': {
                'currentPassword': '',
                'newPassword': '',
                'confirmNewPassword': ''
            },
            'changePasswordMessage': '',
            'resetSuccess': false
        };
    },
    'methods': {
        submitChangePassword () {
            this.$validator.validateAll().then((isValid) => {
                if (!isValid) {
                    return 0;
                }

                const payload = {
                    'OldPassword': this.form.currentPassword,
                    'Password': this.form.newPassword,
                    'PasswordConfirmation': this.form.confirmNewPassword
                };

                // console.log(payload);

                this.axios.post('Clinic/ClinicStaff/ChangePassword', payload).then(() => {
                    this.resetSuccess = true;
                    this.changePasswordMessage = 'Your password has been updated!';

                    this.cancelChangePassword();
                }).catch((error) => {
                    this.resetSuccess = false;
                    this.changePasswordMessage = error.response.data.message;
                    this.cancelChangePassword();
                });
            });
        },
        cancelChangePassword () {
            this.form.currentPassword = '';
            this.form.newPassword = '';
            this.form.confirmNewPassword = '';

            this.$validator.reset();
        }
    }
};

</script>

<style>

</style>
